export default __webpack_public_path__ + "static/media/Filters.92f86c18.svg";